import * as React from 'react';

import ChatFooter from 'bundles/ai-coach-platform/components/patterns/chat/ChatFooter';

import _t from 'i18n!nls/unified-common';

const CourseraAiFooter = () => {
  return <ChatFooter coachPersona={{ name: _t('Ask Coursera'), avatar: null }} />;
};

export default CourseraAiFooter;
